import VectorSource from "ol/source/Vector";

const layersVectorSource = {
    GNA: {
        punti: new VectorSource(),
        linee: new VectorSource(),
        poligoni: new VectorSource(),
        poligoni2: new VectorSource(),
        progetti: new VectorSource(),
        ricostruitiLinee: new VectorSource(),
        ricostruitiPoligoni: new VectorSource(),
    },
    AltreBancheDati: {
        censimento: new VectorSource(),
        tess: new VectorSource(),
    },
    Concessione: new VectorSource(),
    ICCD: new VectorSource(),
};

export { layersVectorSource };
